import { useQuery } from '@tanstack/react-query';
import { fetchCounts, fetchMine } from './api';

/** Свои сообщения о проблемах. Опрос редкий и только на видимой вкладке. */
export function useMine(enabled = true) {
  return useQuery({
    queryKey: ['support', 'my'],
    queryFn: fetchMine,
    enabled,
    refetchInterval: 120_000,
    refetchIntervalInBackground: false,
    staleTime: 20_000,
  });
}

/** Счётчики разделов владельца — отметка в меню «ждут решения». */
export function useSupportCounts(enabled: boolean) {
  return useQuery({
    queryKey: ['support', 'counts'],
    queryFn: fetchCounts,
    enabled,
    refetchInterval: 120_000,
    refetchIntervalInBackground: false,
    staleTime: 20_000,
  });
}
